__turbopack_context__.v({
  "danger": "styles-module__mpH7Va__danger",
  "label": "styles-module__mpH7Va__label",
  "neutral": "styles-module__mpH7Va__neutral",
  "paused": "styles-module__mpH7Va__paused",
  "success": "styles-module__mpH7Va__success",
  "ticker": "styles-module__mpH7Va__ticker",
});
